import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { RefreshIcon } from '@womcorp/wom-miwom-ui-kit/dist/@theme/assets/svg/pictures';
import {
  ContentStyled as Content,
  TitleStyled as Title,
  BodyStyled as Body,
  NoticeStyled as Notice,
  NoticeIconStyled as NoticeIcon,
  ButtonStyled as Button,
  CancelButtonStyled as CancelButton,
} from './styles/PanelContentStyled';
import { GoogleTagManager, Strings } from '../../../../../helpers';
import useUser from '../../../../../hooks/useUser';

const Landing = ({ close, refresh, warning }) => {
  const {
    plan: { number },
  } = useUser();
  const formatedNumber = Strings.formatPhoneNumber(number);

  useEffect(() => {
    GoogleTagManager.pushToDataLayer({
      event: 'pagina-virtual',
      page: '/ayuda/problemas-red/modal-reinicio-red',
      pageName: 'Problemas de Red - Reinicio de red - Solicitud',
    });
  }, []);

  return (
    <Content>
      {warning}
      <RefreshIcon />
      <Body>
        <Title>Reiniciaremos la señal de tu línea {formatedNumber}</Title>
        Si tienes problemas para navegar o tu conexión es inestable solicita un
        reinicio de señal para mejorarla
      </Body>
      <Button onClick={refresh}>Reiniciar señal</Button>
      <CancelButton variant="text" disableRipple onClick={close}>
        Cancelar
      </CancelButton>
      <Notice>
        <NoticeIcon />
        Debes tener activados los datos móviles en tu equipo
      </Notice>
    </Content>
  );
};

Landing.propTypes = {
  close: PropTypes.func.isRequired,
  refresh: PropTypes.func.isRequired,
  warning: PropTypes.node,
};

Landing.defaultProps = {
  warning: null,
};

export default Landing;
